import { useFormField } from 'cng-common/features/form'
import { ValidationType } from 'cng-common/features/form/configs'
import { MultiInputsControl } from 'partner360/components/multiInputsControl'

import { TRANSLATION_KEYS } from '../../../../../../../../translations'
import { GLOBAL_PARTNER_FORM_KEY } from '../../../../configs'
import { isHpEmail } from '../../helpers/isHpEmail'
import { Label } from '../label/Label'

interface IGlobalFormPbmSelect {
  defaultValue: string[]
}

export const GlobalFormManagerSelect = ({ defaultValue }: IGlobalFormPbmSelect) => {
  const { value, handleChange, validationMessage } = useFormField({
    defaultValue: defaultValue,
    formKey: GLOBAL_PARTNER_FORM_KEY,
    field: 'managers',
    onValidate: isHpEmail,
    validationType: ValidationType.ONCHANGE,
  })

  return (
    <div>
      <Label
        isEmptyValue={!value.length}
        translation={TRANSLATION_KEYS.globalPartnerForm.formFields.globalManager}
        validationMessage={validationMessage}
      />

      <MultiInputsControl
        values={value}
        onChange={handleChange}
        placeholder="Manager"
        maxLen={3}
        minLen={1}
      />
    </div>
  )
}
